/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MotionType {
  SURGE = 'Surge',
  SWAY = 'Sway',
  HEAVE = 'Heave',
  YAW = 'Yaw',
  PITCH = 'Pitch',
  ROLL = 'Roll',
}
